import React from 'react';
import { Alert, Divider, Snackbar } from '@mui/material';
import Portal from '@mui/material/Portal';
import { ModalAlert } from './ModalAlert';

type ErrorLevel = 'error' | 'info' | 'warning' | 'success';
interface AlertState {
  level: ErrorLevel;
  message: string;
  messageKey: number;
  duration: number;
  messageDesc?: string;
  type?: 'toast' | 'modal';
}

let setAlert: any;

function useAlert(callback: any) {
  setAlert = callback;
}

export function showAlert(level: ErrorLevel, message: string, duration?: number, messageDesc?: string, type?: 'toast' | 'modal') {
  if (!setAlert) {
    return;
  }
  setAlert({ level, message, messageKey: new Date().getTime(), duration: duration ?? 2000, messageDesc, type: type ?? 'toast' });
}

export function AlertMessage() {
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState<AlertState | null>(null);

  useAlert(setMessage);

  React.useEffect(() => {
    if (message && message.message) {
      setOpen(true);
    }
  }, [message]);

  const handleClose = () => {
    setOpen(false);
  };

  if (message?.type === 'modal') {
    return (
      <ModalAlert open={open} onClose={handleClose}>
        <div style={{ padding: '2rem' }}>
          <ModalAlert.Icon severity={message.level} />
          <ModalAlert.Content messageTitle={message.message} messageDesc={message.messageDesc} />
        </div>
        <Divider />
        <ModalAlert.Actions onClose={() => setOpen(false)} />
      </ModalAlert>
    )
  }

  return (
    message && (
      <Portal>
        <Snackbar
          key={message.messageKey}
          open={open}
          onClose={handleClose}
          autoHideDuration={message.duration}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert severity={message.level}>{message.message}</Alert>
        </Snackbar>
      </Portal>
    )
  );
}
